import * as React from "react";
import {
  ActivityFragment,
  ContractTemplateMinimalFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";

import useTranslations from "../../../hooks/useTranslations";
import { ContractIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type ContractTemplateUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: ContractTemplateMinimalFragment;
};

export function isContractTemplateUpdatedActivity(
  q: ActivityFragment
): q is ContractTemplateUpdatedActivity {
  return q.key === "contract_template.updated";
}

interface ContractTemplateUpdatedActivityProps {
  activity: ContractTemplateUpdatedActivity;
}

export const ContractTemplateUpdatedActivity: React.FC<ContractTemplateUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="contractTemplateUpdatedActivity"
      visual={<ContractIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.contractTemplateUpdated", {
          contractTemplate: (
            <Link
              to={`/contracts/templates/edit/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.contractTemplate")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
